module.exports = __webpack_public_path__ + "static/scale-model-of-old-chinese-telephone-exchange-in-berkeley-california-b79b892b5c2e55a3854fcc9fc1172d71.png";